import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select, { components } from "react-select";
import { useGetSupplierDestinationQuery } from "../../../rtk-query/slices/select-options/selectOptionsSlice";
import { formatJobTitles } from "../../../helpers/selectOptionFormatter";
import { usePostSupplierSavePrivateInformationMutation } from "../../../rtk-query/slices/onboarding/personalDetailSlice";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

function EPPersonalDetailsTabContent({ setCurrentTab, userInfo }) {
  const { data: jobTitleOptionsData } = useGetSupplierDestinationQuery();

  const [formState, setFormState] = useState({
    bookingOption: "",
    fullName: "",
    jobTitle: "",
    phoneNumber: "",
    termsAccepted: false,
    companyCertificate: null,
  });

  useEffect(() => {
    if (userInfo) {
      setFormState({
        ...formState,
        fullName: userInfo?.supplier_user_full_name,
        phoneNumber: userInfo?.supplier_user_phone,
        jobTitle: userInfo?.designation && {
          value: userInfo?.designation?.id,
          label: userInfo?.designation?.designation_name,
        },
        bookingOption:
          userInfo?.supplier?.is_online_reservation !== null
            ? userInfo?.supplier?.is_online_reservation === 1
              ? "yes"
              : "no"
            : "",
        companyCertificate:
          userInfo?.supplier?.company_registration_certificate,
        termsAccepted: userInfo?.user?.terms_accepted,
      });
    }
  }, [userInfo]);

  const updateFormState = (newState) => {
    setFormState((prevState) => ({ ...prevState, ...newState }));
  };
  const navigate = useNavigate();
  const jobTitleOptions = jobTitleOptionsData?.data
    ? formatJobTitles(jobTitleOptionsData?.data)
    : [];

  const [
    postSupplierSavePrivateInformation,
    { isLoading: isPostSupplierSavePrivateInformationLoading },
  ] = usePostSupplierSavePrivateInformationMutation();

  const formik = useFormik({
    initialValues: {
      fullName: formState.fullName || "",
      jobTitle: formState.jobTitle || "",
      phoneNumber: formState.phoneNumber || "",
      termsAccepted: formState.termsAccepted || false,
      companyCertificate: formState.companyCertificate || null,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      fullName: Yup.string().required("Please enter your full name"),
      jobTitle: Yup.object().required("Please enter your job title"),
      phoneNumber: Yup.string().required("Please enter your phone number"),
      // companyCertificate: Yup.mixed()
      //   .test("fileOrUrl", "Company certificate is required", (value) => {
      //     // Value must be either a valid file or a valid URL
      //     if (value === null || value === "") return false;

      //     // If it's a file object, ensure the size/type checks
      //     if (typeof value === "object" && value.size) {
      //       const isValidSize = value.size <= 20000000; // 20MB size check
      //       const isValidType = [
      //         "application/pdf",
      //         "image/jpeg",
      //         "image/png",
      //       ].includes(value.type); // File type check
      //       return isValidSize && isValidType;
      //     }

      //     // If it's a string, check if it's a valid URL
      //     if (typeof value === "string") {
      //       const isValidUrl = /^(ftp|http|https):\/\/[^ "]+$/.test(value); // URL check
      //       return isValidUrl;
      //     }

      //     // Invalid if neither file nor URL
      //     return false;
      //   })
      //   .test("fileSize", "File size is too large", (value) => {
      //     // If it's a file, check size
      //     if (typeof value === "object" && value.size) {
      //       return value.size <= 20000000;
      //     }
      //     // If it's a URL or null, skip size check
      //     return true;
      //   })
      //   .test(
      //     "fileType",
      //     "Unsupported file format. Please upload a PDF, JPG, or PNG file.",
      //     (value) => {
      //       // If it's a file, check file type
      //       if (typeof value === "object" && value.type) {
      //         return ["application/pdf", "image/jpeg", "image/png"].includes(
      //           value.type
      //         );
      //       }
      //       // If it's a URL or null, skip type check
      //       return true;
      //     }
      //   ),
    }),

    onSubmit: async (values) => {
      try {
        console.log("====================================");
        console.log("values", values);
        console.log("====================================");
        const formData = new FormData();
        formData.append("full_name", values.fullName);
        formData.append("job_title", values.jobTitle.value);
        formData.append("user_phone_number", values.phoneNumber);
        values.companyCertificate &&
          formData.append(
            "company_registration_certificate",
            values.companyCertificate
          );
        formData.append("is_online_reservation", formState.bookingOption);

        const response = await postSupplierSavePrivateInformation(formData);
        if (response?.data?.status) {
          toast.success(response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
        }
        if (response?.error) {
          const errors = response?.error?.data?.errors;
          if (response?.error?.status == 401) {
            localStorage.removeItem("DODLoginToken");
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
            navigate("/login");
          } else if (errors) {
            for (const field in errors) {
              if (errors.hasOwnProperty(field)) {
                const combinedErrors = errors[field].join(" ");
                // if (field === "supplier_type") {
                //   setFieldError("option", combinedErrors);
                // }
              }
            }
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          } else {
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        toast.error("An unexpected error occurred. Please try again.");
      } finally {
      }
    },
  });
  const handleCertificateChange = (e) => {
    const file = e.target.files[0];
    formik.setFieldValue("companyCertificate", file); // Set file input value in Formik state
  };
  return (
    <div className="w-100 p-0">
      <h3 className="usr-p-pi-title">Personal details</h3>

      <Form className="mt-4" onSubmit={formik.handleSubmit}>
        <div className="row p-0 m-0">
          <Form.Group
            controlId="experienceLocation"
            className="col-lg-6 ps-0 pe-lg-2 pe-0"
          >
            <p className="ob-pi-label m-0">Full name</p>
            <div className="position-relative">
              <Form.Control
                type="text"
                name="fullName"
                placeholder="Full name"
                className="ob-pi-input mt-1"
                value={formik.values.fullName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.errors.fullName && formik.touched.fullName && (
                <div className="invalid-feedback d-flex">
                  {formik.errors.fullName}
                </div>
              )}
            </div>
          </Form.Group>

          <Form.Group
            controlId="aboutYourself"
            className=" col-lg-6 p-0 m-0 pe-0 ps-lg-2 ps-0"
          >
            <p className="ob-pi-label">Job title</p>
            <Select
              name="jobTitle"
              options={jobTitleOptions}
              placeholder="Search job title"
              className="ob-pi-input mt-1 p-0 form-control"
              value={formik.values.jobTitle}
              onChange={(e) => {
                formik.setFieldValue("jobTitle", e);
              }}
              components={{
                Control: ({ children, ...props }) => {
                  return (
                    <components.Control {...props}>
                      {children}
                      <div className="select-icon">
                        <Icon icon="ic:baseline-keyboard-arrow-down" />
                      </div>
                    </components.Control>
                  );
                },
              }}
            />

            {formik.errors.jobTitle && formik.touched.jobTitle && (
              <div className="invalid-feedback d-flex">
                {formik.errors.jobTitle}
              </div>
            )}
          </Form.Group>
        </div>
        <div className="row p-0 m-0">
          <Form.Group
            controlId="phoneNumber"
            className="mt-4 col-lg-6 ps-0 pe-lg-2 pe-0"
          >
            <p className="ob-pi-label">Preferred phone number</p>
            <PhoneInput
              country={"ae"}
              placeholder="Company-contact-number-number"
              inputClass="ob-pi-input w-100 mt-1"
              value={formik.values.phoneNumber}
              onChange={(phone) => formik.setFieldValue("phoneNumber", phone)}
            />
            {formik.errors.phoneNumber && formik.touched.phoneNumber && (
              <div className="invalid-feedback d-flex">
                {formik.errors.phoneNumber}
              </div>
            )}
          </Form.Group>

          <Form.Group
            controlId="companyRegistrationNumber"
            className="mt-4 col-lg-6 p-0 m-0 pe-0 ps-lg-2 ps-0 "
          >
            <p className="ob-pi-label">Company registration certificate</p>
            <div className="position-relative">
              <input
                type="file"
                id="certificateUpload"
                style={{
                  height: "37px",
                }}
                maxLength={1024 * 1024 * 20}
                accept="image/jpeg,image/png,application/pdf"
                onChange={handleCertificateChange}
                className="form-control mt-1"
              />
              {typeof formik.values.companyCertificate === "string" && (
                <div className="ep-psdtc-file">
                  <Link
                    to={formik.values.companyCertificate}
                    target="_blank"
                    className="btn btn-link ep-psdtc-file-link-text "
                  >
                    {formik.values.companyCertificate?.split("/").pop()}
                  </Link>
                </div>
              )}
              {formik.errors.companyCertificate &&
                formik.touched.companyCertificate && (
                  <div className="invalid-feedback d-flex">
                    {formik.errors.companyCertificate}
                  </div>
                )}
            </div>
          </Form.Group>
        </div>

        <div className="d-flex justify-content-center align-items-center gap-4 mt-5">
          <button type="button" className="review-button">
            Cancel
          </button>
          <button
            disabled={isPostSupplierSavePrivateInformationLoading}
            type="submit"
            className="review-button-submit review-button"
          >
            Save & Continue{" "}
            {isPostSupplierSavePrivateInformationLoading && (
              <Spinner size="sm" />
            )}
          </button>
        </div>
      </Form>
    </div>
  );
}

export default EPPersonalDetailsTabContent;
